const env = typeof window !== 'undefined' ? window.ENV : process.env

export const config = {
	projectId: env.SANITY_PROJECT_ID,
	dataset: env.SANITY_DATASET,
	useCdn: process.env.NODE_ENV === 'production',
	apiVersion: env.SANITY_API_VERSION,
}
